import React from "react";
import ReactDOM from "react-dom/client";
import { addScriptToHead } from "./helpers/helpers";
import appSettings from "./settings/appSettings.ts";
import loadBraintreeScripts from "./braintree/loadBraintreeScripts";
import { Product, OrderLineMeta } from "./types";
const googleApiKey = "AIzaSyCKd9L_v3zLg2OQXirYsL16KZ8vzdUqkWs";

export type CheckoutOpts = {
  checkoutId?: string;
  mapProducts?: (products: Product[]) => Product[];
};

export type CheckoutInstance = {
  parentElement: HTMLElement;
  checkoutElement: HTMLElement;
  render: () => void;
};

export function wvusFlexCheckout(
  parentElement: HTMLElement,
  opts: CheckoutOpts = {}
): CheckoutInstance {
  if (!parentElement.appendChild) {
    throw new Error("First argument needs to be an HTML Element");
  }

  const checkoutElement = window.document.createElement("div");
  checkoutElement.id = opts.checkoutId ?? `wvCheckout${Date.now()}`;

  if (!opts.mapProducts) {
    opts.mapProducts = (products) => {
      const frequencyMap = {
        monthly: "mon",
        mon: "mon",
        yearly: "yr",
        yr: "yr",
        annually: "yr"
      };

      return products.map((product) => {
        const lineMeta: OrderLineMeta = {
          productTitle: product.productTitle || product.title || product.name
        };

        if (product.frequency && frequencyMap[product.frequency]) {
          lineMeta.pa_uom = frequencyMap[product.frequency];
        }

        const productMeta = { ...(product.lineMeta || product.meta || product.productMeta || {}) };

        return {
          productId: product.productId || product.product_id,
          quantity: product.quantity || product.qty || 1,
          total: product.total || product.price || product.amount || product.amt,
          lineMeta: {
            ...lineMeta,
            ...productMeta
          }
        };
      });
    };
  }

  parentElement.appendChild(checkoutElement);

  const instance = {
    parentElement,
    checkoutElement,
    render: () => {}
  };

  const render = async () => {
    const { appType = "artist-tour", google_recaptcha_site_key } = appSettings;

    let App;

    if (appType === "chosen") {
      App = await import("./components/ChosenApp/ChosenAppWrapper.tsx").then(
        (module) => module.default
      );
    } else if (appType === "artist-tour") {
      App = await import("./components/TourApp/TourAppWrapper.tsx").then(
        (module) => module.default
      );
    } else {
      // Default to TourApp
      App = await import("./components/TourApp/TourAppWrapper.tsx").then(
        (module) => module.default
      );
    }

    // Load Google reCAPTCHA script separately
    addScriptToHead(
      `https://www.google.com/recaptcha/api.js?render=${google_recaptcha_site_key}`,
      { defer: true }
    ).catch((error) => {
      console.error("Google reCAPTCHA failed to load:", error);
    });

    Promise.allSettled([
      addScriptToHead(
        `https://maps.googleapis.com/maps/api/js?key=${googleApiKey}&callback=initAutocomplete&libraries=places&v=weekly`,
        { defer: true }
      ),
      ...loadBraintreeScripts()
    ]).finally(async () => {
      ReactDOM.createRoot(checkoutElement as HTMLElement).render(
        <React.StrictMode>
          <App
            opts={{
              ...opts
            }}
          />
        </React.StrictMode>
      );
    });
  };

  instance.render = render;

  wvusFlexCheckout.instances[checkoutElement.id] = instance;

  return instance;
}

globalThis.initAutocomplete = () => {};

wvusFlexCheckout.instances = {};

export default wvusFlexCheckout;
